import { EntityDocumentsOrderBy } from 'common/types/globalTypes';
import { orderByMap } from 'common/utils/actionMenuUtils';
import { SortOrder } from 'common/utils/commonTypes';

export const toOrderByVariable = (
  sort?: SortOrder
): EntityDocumentsOrderBy[] => {
  const orderByArray: EntityDocumentsOrderBy[] = [
    '_UPLOAD_DATE_DESC',
    'PRIMARY_KEY_DESC',
  ];

  if (!sort) return orderByArray;

  const orderBy = orderByMap.get(sort.column)?.[sort.direction];
  return [...(orderBy ?? []), 'PRIMARY_KEY_DESC'];
};
